import React, { Fragment, useEffect, useState } from "react";
import { Pagina } from "../template/Template";
import { AuthContext } from "../../App";

import DialogoLocalidade from "./cliente/DialogoLocalidade";
import { ThemeProvider } from "@material-ui/core/styles";
import { Formik } from "formik";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";

import Select from "@mui/material/Select";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Switch from "@material-ui/core/Switch";

import {
    DataGrid,
    GridToolbarContainer,
    GridFilterToolbarButton,
} from "@material-ui/data-grid";

import {
    ButtonCancel,
    ButtonDelete,
    ButtonSave,
    ButtonUpdate,
} from "../botoes/operacao";

import {
    clienteAlgoritimoDropDown
} from "../../services/ClienteAlgoritimoService";



import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import AddHomeWork from "@material-ui/icons/AccountBalance";
import AddToQueueIcon from "@material-ui/icons/AddToQueue";
import FlipIcon from "@material-ui/icons/Flip";

import { format } from "date-fns";
import { Loading } from "../Loading";
import { ShowMessageBox } from "../ShowMessageBox";
import { PickList } from "primereact/picklist";

import { Calendar } from "primereact/calendar";
import {
    clientexsiteInsert,
    clientexsiteDelete,
    clientexsiteDispEmUso,
    clientexsiteUpdate,
} from "../../services/ClientexSiteService";


import { addLocale } from "primereact/api";
import {
    clienteDelete,
    clienteFindAll,
    clienteInsert,
    clienteUpdate,
} from "../../services/ClienteService";
import {
    clientexservicoDispEmUso,
    clientexservicoInsert,
} from "../../services/ClientexServicoService";
import { Tooltip } from "@material-ui/core";
import { useStyles } from '../styles/StyleCliente';
import { theme } from "../styles/Theme";

let inserir = false;

let severity = "success";
let msg = "";

export default function Cliente() {
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);

    addLocale("pt", {
        firstDayOfWeek: 1,
        dayNames: [
            "domingo",
            "segunda",
            "terça",
            "quarta",
            "quinta",
            "sexta",
            "sábado",
        ],
        dayNamesShort: ["dom", "seg", "tec", "qua", "qui", "sex", "sáb"],
        dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
        monthNames: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
        ],
        monthNamesShort: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
        ],
        today: "Hoje",
        clear: "Limpar",
        //...
    });

    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [openDialogLocalidade, setOpenDialogLocalidade] = React.useState(false);

    const [listCliente, setListCliente] = React.useState([]);
    const [selection, setSelection] = React.useState({});

    // const [listSite, setListSite] = React.useState([]);
    const [openLoading, setOpenLoading] = React.useState(false);
    const [openDialogAssignClienteToSite, setOpenDialogAssignClienteToSite] =
        React.useState(false);
    const [
        openDialogAssignClienteToServico,
        setOpenDialogAssignClienteToServico,
    ] = React.useState(false);

    const closeDialogoLocalidade = () => {
        inserir = false;
        console.log("closeDialogoLocalidade");
        setOpenDialogLocalidade(false);
    };

    const closeDialog = () => {
        inserir = false;
        setOpenDialog(false);
    };

    const closeDialogAssignClienteToSite = () => {
        inserir = false;
        setOpenDialogAssignClienteToSite(false);
    };
    const closeDialogAssignClienteToServico = () => {
        inserir = false;
        setOpenDialogAssignClienteToServico(false);
    };

    //*? SITES ----------------------------

    const DialogoSites = () => {
        const [openLoadingDialog, setOpenLoadingDialog] = React.useState(false); //loading
        const [openSnackBarDialog, setOpenSnackBarDialog] = React.useState(false);
        const [sitesDisponiveis, setSitesDisponiveis] = useState([]);
        const [sitesEmUso, setSitesEmUso] = useState([]);
        const [dateInicio, setDateInicio] = useState(null);

        const [dateInicioUpdate, setDateInicioUpdate] = useState(null);
        //const [calendarInicial, setCalendarIncial] = useState(null);
        // const [dateFim, setDateFim] = useState(null);
        const [dateFimUpdate, setDateFimUpdate] = useState(null);

        const [sitId, setSitId] = React.useState([]);
        const [sitIdUp, setSitIdUp] = React.useState([]);

        const handleChangeInsert = async (event) => {
            setSitId(event.target.value);
        };

        const handleChangeUp = async (event) => {
            setSitIdUp(event.target.value);
            const selectedSite = sitesEmUso.find(
                (site) => site.sit_id === event.target.value
            );

            const sitDateInicial = selectedSite ? selectedSite.cxi_dt_inicio : null;

            // Verifica se a data inicial existe antes de formatar
            //const formattedDate = sitDateInicial
            //    ? new Date(sitDateInicial).toLocaleDateString("pt-BR")
            //    : null;

            //setCalendarIncial(formattedDate);

            setDateInicioUpdate(new Date(sitDateInicial));
        };

        const concluirInsert = async () => {
            try {
                setOpenSnackBarDialog(false);
                const sitesData = {
                    cli_id: selection.cli_id,
                    sit_id: sitId,
                    cxi_dt_inicio: dateInicio,
                };

                if (!selection.cli_id || !sitId || !dateInicio) {
                    msg = "Campos para adição de site não podem estar vazios";
                    severity = "error";
                    setOpenSnackBarDialog(true);
                    setOpenLoadingDialog(false);
                } else {
                    await clientexsiteInsert(sitesData);
                    const respSite = await clientexsiteDispEmUso(selection.cli_id);
                    setSitesEmUso(respSite.data.emuso);
                    setSitesDisponiveis(respSite.data.disponivel);

                    setSitId("");
                    setDateInicio(null);
                    setSitIdUp(null);
                    setDateFimUpdate(null);
                    setDateInicioUpdate(null);

                    msg = "Site inserido com sucesso";
                    severity = "success";
                    setOpenSnackBarDialog(true);
                    setOpenLoadingDialog(false);
                }
            } catch (err) {
                msg = `Cliente não pode ser associado ao mesmo site.`;
                severity = "error";
                setOpenSnackBarDialog(true);
                setOpenLoadingDialog(false);
            }
        };

        //console.log(calendarInicial);

        const deleteCliSite = async () => {
            try {
                setOpenSnackBarDialog(false);

                await clientexsiteDelete(selection.cli_id, sitIdUp);

                const respSite = await clientexsiteDispEmUso(selection.cli_id);
                setSitesEmUso(respSite.data.emuso);
                setSitId("");
                setDateInicioUpdate(null);
                setDateFimUpdate(null);

                //setCalendarIncial(null);
                msg = "Site excluído com sucesso";
                severity = "success";
                setOpenSnackBarDialog(true);
                setOpenLoadingDialog(false);
                setSitesDisponiveis(respSite.data.disponivel);
            } catch (err) {
                msg = `${err}`;
                severity = "error";
                setOpenSnackBarDialog(true);
                setOpenLoadingDialog(false);
            }
        };

        const concluirUpdate = async () => {
            try {
                setOpenSnackBarDialog(false);
                const dateInUp = format(dateInicioUpdate, "yyyy-MM-dd");
                const dateFimUp = dateFimUpdate
                    ? format(dateFimUpdate, "yyyy-MM-dd")
                    : "None";

                console.log(
                    "sites update: ",
                    selection.cli_id + sitIdUp,
                    dateInUp,
                    dateFimUp
                );

                if (dateInUp > dateFimUp) {
                    msg = "Data de início não pode ser maior que a data final";
                    severity = "error";
                    setOpenSnackBarDialog(true);
                    setOpenLoadingDialog(false);
                } else if (!sitIdUp) {
                    msg = "Site para atualização não encontrado";
                    severity = "error";
                    setOpenSnackBarDialog(true);
                    setOpenLoadingDialog(false);
                } else {
                    console.log("chegou");

                    await clientexsiteUpdate(
                        selection.cli_id,
                        sitIdUp,
                        dateInUp,
                        dateFimUp
                    );

                    setSitId("");
                    setSitIdUp("");
                    setDateInicioUpdate(null);
                    //setCalendarIncial(dateInUp);
                    setDateFimUpdate(null);

                    const respSite = await clientexsiteDispEmUso(selection.cli_id);
                    setSitesEmUso(respSite.data.emuso);
                    setSitesDisponiveis(respSite.data.disponivel);

                    msg = "Cliente atualizado com sucesso";
                    severity = "success";
                    setOpenSnackBarDialog(true);
                    setOpenLoadingDialog(false);
                }
            } catch (err) {
                console.log(err);
            }
        };

        useEffect(async () => {
            setOpenLoadingDialog(true);

            try {
                if (selection.cli_id) {
                    clientexsiteDispEmUso(selection.cli_id);
                    const respSite = await clientexsiteDispEmUso(selection.cli_id);
                    setSitesDisponiveis(respSite.data.disponivel);
                    setSitesEmUso(respSite.data.emuso);
                    setOpenLoadingDialog(false);
                }
            } catch (err) {
                console.log(err);
                setOpenLoadingDialog(false);
            }
        }, [selection]);

        // const itemTemplate = (item) => {
        //   return (
        //     <div className="site-item">
        //       <div className="site-list-detail">
        //         <span className="site">{item.sit_id}</span>
        //       </div>
        //     </div>
        //   );
        // };

        return (
            <Dialog
                open={openDialogAssignClienteToSite}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth="md"
                style={{ zIndex: 1000 }}
            >
                <div
                    id="form-dialog-title"
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        paddingRight: "2rem",
                        paddingLeft: "2rem",
                        alignItems: "center",
                        background: "lightblue",
                        height: "4rem",
                    }}
                >
                    <span style={{ fontSize: "1.2rem" }}>
                        Seleção de Site: <b>{selection.cli_apelido}</b>
                    </span>
                    <ButtonCancel
                        variant="contained"
                        color="primary"
                        type="button"
                        style={{
                            padding: "3px",
                            color: "white",
                            fontWeight: "bold",
                        }}
                        onClick={closeDialogAssignClienteToSite}
                    >
                        <CloseIcon />
                    </ButtonCancel>
                </div>

                <DialogContent>
                    <Loading open={openLoadingDialog} />
                    <ShowMessageBox
                        open={openSnackBarDialog}
                        setOpen={setOpenSnackBarDialog}
                        severity={severity}
                        msg={msg}
                    />
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div
                            style={{
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "100px",
                                padding: "2rem",
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <h3> Adicionar </h3>
                            </div>

                            <FormControl style={{ width: "300px", marginBottom: "1.5rem" }}>
                                <InputLabel id="demo-simple-select-label">Site</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={sitId}
                                    label="Site"
                                    onChange={handleChangeInsert}
                                >
                                    {sitesDisponiveis.map((site, index) => (
                                        <MenuItem key={index} value={site.sit_id}>
                                            {site.sit_id}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <span className="p-float-label">
                                <Calendar
                                    style={{
                                        zIndex: 1001,
                                        marginBottom: "1.5rem",
                                        alignItems: "center",
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "11rem",
                                    }}
                                    inputId="cxi_dt_inicio"
                                    value={dateInicio}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    locale="pt"
                                    onChange={(e) => setDateInicio(e.value)}
                                />
                                <label style={{ zIndex: 1001 }} htmlFor="cxi_dt_inicio">
                                    Data inicial
                                </label>
                            </span>

                            {/* <span className="p-float-label">
              <Calendar
                style={{ zIndex: 1001 }}
                inputId="cxi_dt_fim"
                value={dateFim}
                dateFormat="dd/mm/yy"
                onChange={(e) => setDateFim(e.value)}
              />
              <label style={{ zIndex: 1001 }} htmlFor="cxi_dt_fim">
                Data final
              </label>
            </span> */}

                            <ButtonSave
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={concluirInsert}
                                style={{
                                    padding: "5px",
                                    color: "white",
                                    fontWeight: "bold",
                                    height: "2rem",
                                    width: "5rem",
                                }}
                            >
                                Inserir
                            </ButtonSave>
                        </div>

                        <span
                            style={{ border: "lightgray solid 1px", height: "50vh" }}
                        ></span>

                        {/* //! ATUALIZAR CLIENTE  ------------------------------------------------- */}

                        <div style={{ display: "column", padding: "2rem" }}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <h3> Atualização </h3>
                            </div>
                            <div
                                style={{
                                    justifyContent: "space-evenly",
                                    alignItems: "center",
                                }}
                            >
                                <FormControl style={{ width: "300px", marginBottom: "1.5rem" }}>
                                    <InputLabel id="demo-simple-select-label">Site</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={sitIdUp}
                                        label="Site"
                                        onChange={handleChangeUp}
                                    >
                                        {sitesEmUso.map((site, index) => (
                                            <MenuItem key={index} value={site.sit_id}>
                                                {site.sit_id}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <span className="p-float-label">
                                    <Calendar
                                        ini
                                        style={{
                                            zIndex: 1001,
                                            marginBottom: "1.5rem",
                                            alignItems: "center",
                                            display: "flex",
                                            justifyContent: "center",
                                            width: "11rem",
                                        }}
                                        inputId="cxi_dt_inicio_update"
                                        value={dateInicioUpdate}
                                        dateFormat="dd/mm/yy"
                                        locale="pt"
                                        showIcon
                                        onChange={(e) => setDateInicioUpdate(e.value)}
                                    />
                                    <label
                                        style={{ zIndex: 1001 }}
                                        htmlFor="cxi_dt_inicio_update"
                                    >
                                        Data inicial
                                    </label>
                                </span>
                                <span className="p-float-label">
                                    <Calendar
                                        style={{
                                            zIndex: 1001,
                                            marginBottom: "1.5rem",
                                            alignItems: "center",
                                            display: "flex",
                                            justifyContent: "center",
                                            width: "11rem",
                                        }}
                                        inputId="cxi_dt_inicio_update"
                                        value={dateFimUpdate}
                                        locale="pt"
                                        dateFormat="dd/mm/yy"
                                        showIcon
                                        onChange={(e) => setDateFimUpdate(e.value)}
                                    />
                                    <label
                                        style={{ zIndex: 1001 }}
                                        htmlFor="cxi_dt_inicio_update"
                                    >
                                        Data Final
                                    </label>
                                </span>

                                <div style={{ display: "flex" }}>
                                    <ButtonUpdate
                                        variant="contained"
                                        size="small"
                                        color="primary"
                                        onClick={concluirUpdate}
                                        style={{
                                            padding: "5px",
                                            color: "white",
                                            fontWeight: "bold",
                                            height: "2rem",
                                            width: "5rem",
                                        }}
                                    >
                                        Atualizar
                                    </ButtonUpdate>
                                    <ButtonDelete
                                        variant="contained"
                                        color="primary"
                                        type="button"
                                        disabled={!sitIdUp}
                                        style={{
                                            padding: "5px",
                                            color: "white",
                                            fontWeight: "bold",
                                            height: "2rem",
                                            width: "3rem",
                                        }}
                                        onClick={deleteCliSite}
                                    >
                                        <DeleteForeverIcon />
                                    </ButtonDelete>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        );
    };

    //*? SERVICOS ----------------------------

    const DialogoServicos = () => {
        const [openLoadingDialog, setOpenLoadingDialog] = React.useState(false); //loading
        const [openSnackBarDialog, setOpenSnackBarDialog] = React.useState(false);
        // const [selectedItem, setSelectedItem] = useState(null);
        const [source, setSource] = React.useState([]);
        const [target, setTarget] = React.useState([]);

        const concluirServicos = async () => {
            try {
                const targets = target.map((e) => e.ser_id);
                await clientexservicoInsert(selection.cli_id, targets);

                msg = "Serviço inserido com sucesso";
                severity = "success";
                setOpenSnackBarDialog(true);
                setOpenLoadingDialog(false);

                // closeDialogAssignClienteToServico(true);
            } catch (err) {
                console.log(err);
                msg = "Erro ao inserir serviço";
                severity = "error";
                setOpenSnackBarDialog(true);
                setOpenLoadingDialog(false);
            }
        };

        useEffect(async () => {
            setOpenLoadingDialog(true);

            try {
                if (selection.cli_id) {
                    // clientexservicoFindAllById(selection.cli_id);
                    const respServico = await clientexservicoDispEmUso(selection.cli_id);
                    setSource(respServico.data.disponivel);
                    setTarget(respServico.data.emuso);
                    //console.log("Valor inicial de target:", respServico.data.emuso);
                    //console.log(
                    //    "Valor inicial de disponivel:",
                    //    respServico.data.disponivel
                    //);
                    setOpenLoadingDialog(false);
                }
            } catch (err) {
                console.log(err);
                setOpenLoadingDialog(false);
            }
        }, [selection]);

        const onChange = (e) => {
            setSource(e.source);
            setTarget(e.target);
            console.log("Source", e.source);
            console.log("Target", e.target);
        };

        const itemTemplate = (item) => {
            return (
                <div className="site-item">
                    <div className="site-list-detail">
                        <span className="site">{item.ser_nome}</span>
                    </div>
                </div>
            );
        };

        return (
            <Dialog
                open={openDialogAssignClienteToServico}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth="md"
            >
                <div
                    id="form-dialog-title"
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        paddingRight: "2rem",
                        paddingLeft: "2rem",
                        alignItems: "center",
                        background: "lightblue",
                        height: "4rem",
                        marginBottom: "1.2rem",
                    }}
                >
                    <span style={{ fontSize: "1.2rem" }}>
                        Seleção de Serviço: <b>{selection.cli_apelido}</b>
                    </span>
                    <ButtonCancel
                        variant="contained"
                        color="primary"
                        type="button"
                        style={{
                            padding: "3px",
                            color: "white",
                            fontWeight: "bold",
                        }}
                        onClick={closeDialogAssignClienteToServico}
                    >
                        <CloseIcon />
                    </ButtonCancel>
                </div>

                <DialogContent>
                    <Loading open={openLoadingDialog} />
                    <ShowMessageBox
                        open={openSnackBarDialog}
                        setOpen={setOpenSnackBarDialog}
                        severity={severity}
                        msg={msg}
                    />
                    <PickList
                        source={source}
                        target={target}
                        itemTemplate={itemTemplate}
                        sourceHeader="Disponível"
                        targetHeader="Selecionado"
                        onChange={onChange}
                    />
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end",
                        }}
                    >
                        <ButtonSave
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={concluirServicos}
                            style={{ padding: "3px", color: "white", fontWeight: "bold" }}
                        >
                            Concluir
                        </ButtonSave>
                    </div>
                </DialogContent>
            </Dialog>
        );
    };

    //*? MAIN DIALOG

    const Dialogo = () => {
        const [openLoadingDialog, setOpenLoadingDialog] = React.useState(false);
        const [openSnackBarDialog, setOpenSnackBarDialog] = React.useState(false);
        const [listClienteAlgoritimo, setListClienteAlgoritimo] = React.useState([]);


        useEffect(async () => {
            const respAlgoritimo = await clienteAlgoritimoDropDown();
            setListClienteAlgoritimo(respAlgoritimo.data);
        }, []);


        const deleteRecord = async () => {
            setOpenSnackBarDialog(false);

            const cliente = selection.cli_id;
            try {
                setOpenLoadingDialog(true);
                await clienteDelete(cliente);
                const respCliente = await clienteFindAll();
                setListCliente(respCliente.data);
                setOpenDialog(false);
                setOpenLoadingDialog(false);
                inserir = true;
            } catch (error) {
                msg =
                    "Erro ao excluir o cliente. Cliente está sendo utilizado pelo sistema";
                severity = "error";
                console.log(error);
                setOpenSnackBarDialog(true);
                setOpenLoadingDialog(false);
            }
        };

        return (
            <Dialog open={openDialog} aria-labelledby="form-dialog-title">
                <div
                    id="form-dialog-title"
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        paddingRight: "2rem",
                        paddingLeft: "2rem",
                        alignItems: "center",
                        background: "lightblue",
                        height: "4rem",
                        marginBottom: "1.2rem",
                    }}
                >
                    <span style={{ fontSize: "1.2rem" }}>Manutenção de clientes</span>
                    <ButtonCancel
                        variant="contained"
                        color="primary"
                        type="button"
                        style={{
                            padding: "3px",
                            color: "white",
                            fontWeight: "bold",
                        }}
                        onClick={closeDialog}
                    >
                        <CloseIcon />
                    </ButtonCancel>
                </div>
                <DialogContent>
                    <Loading open={openLoadingDialog} />
                    <ShowMessageBox
                        open={openSnackBarDialog}
                        setOpen={setOpenSnackBarDialog}
                        severity={severity}
                        msg={msg}
                    />
                    <Formik
                        initialValues={{
                            cliId: selection.cli_id,
                            cliNome: selection.cli_nome,
                            cliApelido: selection.cli_apelido,
                            calId: selection.cal_id,
                            cliCheckLocal: selection.cli_check_local,
                        }}
                        validate={(values) => {
                            const errors = {};
                            if (!values.cliNome) {
                                errors.cliNome = "Obrigatório";
                            } else if (!values.cliApelido) {
                                errors.cliApelido = "Obrigatório";
                            } else if (!values.cliId) {
                                errors.cliId = "Obrigatório";
                            }
                            return errors;
                        }}
                        onSubmit={async (values, { setSubmitting }) => {
                            setSubmitting(true);
                            setOpenLoadingDialog(true);
                            console.log("-----> Values", values);
                            if (inserir) {
                                try {
                                    await clienteInsert({
                                        cli_nome: values.cliNome,
                                        cli_apelido: values.cliApelido,
                                        cli_id: values.cliId,
                                        cal_id: values.calId,
                                        cli_check_local: values.cliCheckLocal,
                                    });

                                    const respCliente = await clienteFindAll();
                                    setListCliente(respCliente.data);
                                    msg = "Cliente incluido com sucesso";
                                    severity = "success";
                                    setOpenDialog(false);
                                    setOpenLoadingDialog(false);
                                } catch (error) {
                                    msg = "Erro ao inserir cliente";
                                    severity = "error";
                                    setOpenSnackBar(true);
                                    setOpenLoadingDialog(false);
                                }
                            } else {
                                try {
                                    // const cliUpData = values.cliId;

                                    const updateData = {
                                        cli_nome: values.cliNome,
                                        cli_apelido: values.cliApelido,
                                        cal_id: values.calId,
                                        cli_check_local: values.cliCheckLocal,
                                    };

                                    await clienteUpdate(selection.cli_id, updateData);

                                    const respCliente = await clienteFindAll();
                                    setListCliente(respCliente.data);
                                    msg = "Cliente atualizado com sucesso";
                                    severity = "success";
                                    setOpenSnackBar(true);
                                    setOpenDialog(false);
                                    setOpenLoadingDialog(false);
                                } catch (error) {
                                    msg = "Erro ao atualizar cliente";
                                    severity = "error";
                                    console.log(error);
                                    setOpenSnackBar(true);
                                    setOpenLoadingDialog(false);
                                }
                            }
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            isValid,
                        }) => (
                            <form onSubmit={handleSubmit} className={classes.form}>
                                <div className={classes.input_data}>
                                    <TextField
                                        value={values.cliId}
                                        id="cliId"
                                        name="cliId"
                                        type="text"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Id do cliente"
                                        className={classes.nome}
                                        helperText={errors.cliId}
                                        disabled={!inserir}
                                        InputProps={{
                                            readOnly: !inserir,
                                        }}
                                    />

                                    <TextField
                                        value={values.cliNome}
                                        name="cliNome"
                                        id="cliNome"
                                        type="text"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Nome do cliente"
                                        className={classes.nome}
                                        helperText={errors.cliNome}
                                    />

                                    <TextField
                                        value={values.cliApelido}
                                        name="cliApelido"
                                        type="text"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Apelido"
                                        className={classes.nome}
                                        helperText={errors.cliApelido}
                                    />
                                    <FormControl style={{ width: "100%", marginBottom: "1.5rem" }}>
                                        <InputLabel id="demo-simple-select-label">Algoritimo</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="calId"
                                            name="calId"
                                            autoWidth
                                            value={values.calId}
                                            onChange={handleChange}
                                        >
                                            <MenuItem key="0" value="">
                                                Nenhum...
                                            </MenuItem>

                                            {listClienteAlgoritimo.map((c) => (
                                                <MenuItem
                                                    key={c.cal_id}
                                                    value={c.cal_id}
                                                >
                                                    {c.cal_id}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <FormControlLabel
                                        control={<Switch name="cliCheckLocal"
                                            checked={values.cliCheckLocal}
                                            onChange={handleChange} />}
                                        label="Restringir Local"
                                        style={{ marginTop: "1rem" }}
                                    />


                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-around",
                                        }}
                                    ></div>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "flex-end",
                                            marginTop: "1rem",
                                        }}
                                    >
                                        <ButtonSave
                                            variant="contained"
                                            size="small"
                                            color="primary"
                                            type="submit"
                                            style={{
                                                padding: "5px",
                                                color: "white",
                                                fontWeight: "bold",
                                            }}
                                            disabled={!isValid}
                                        >
                                            Salvar
                                        </ButtonSave>
                                        <ButtonDelete
                                            variant="contained"
                                            color="primary"
                                            type="button"
                                            style={{
                                                padding: "5px",
                                                color: "white",
                                                fontWeight: "bold",
                                            }}
                                            onClick={deleteRecord}
                                            disabled={selection.cli_id === "1"}
                                        >
                                            Excluir
                                        </ButtonDelete>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        );
    };

    useEffect(async () => {
        setOpenLoading(true);
        const respCliente = await clienteFindAll();
        setListCliente(respCliente.data);

        setOpenLoading(false);
    }, []);

    const Content = () => {
        const [selectionItem, setSelectionItem] = React.useState({});
        const [selected, setSelected] = React.useState(false);

        const CustomToolbar = () => {
            return (
                <GridToolbarContainer>
                    <GridFilterToolbarButton />
                </GridToolbarContainer>
            );
        };
        const newRecord = () => {
            inserir = true;
            setSelection({
                cli_id: null,
                cli_nome: null,
                cli_apelido: null,
                sit_id: null,
                cli_check_local: false,
                created_at: format(new Date(), "dd-MM-yyyy"),
                updated_at: format(new Date(), "dd-MM-yyyy"),
            });
            setSelected(false);
            setOpenSnackBar(false);
            setOpenDialog(true);
        };

        const editRecord = () => {
            inserir = false;
            //console.log("selectionItem", selectionItem);
            setSelection(selectionItem);
            setSelected(false);
            setOpenSnackBar(false);
            setOpenDialog(true);
        };

        const assignClienteToServico = () => {
            inserir = false;
            setSelected(false);
            setSelection(selectionItem);
            setOpenSnackBar(false);
            setOpenDialogAssignClienteToServico(true);
        };

        const assignClienteToSite = () => {
            inserir = false;
            setSelected(false);
            setSelection(selectionItem);
            setOpenSnackBar(false);
            setOpenDialogAssignClienteToSite(true);
        };
        const openDialogoLocalidade = () => {
            setSelected(false);
            setSelection(selectionItem);
            setOpenDialogLocalidade(true);
        };
        return (
            <Fragment>
                <ShowMessageBox
                    open={openSnackBar}
                    setOpen={setOpenSnackBar}
                    severity={severity}
                    msg={msg}
                />
                <Loading open={openLoading} />
                <Dialogo />
                <DialogoSites />
                <DialogoServicos />
                {openDialogLocalidade &&
                    <DialogoLocalidade
                        isOpened={openDialogLocalidade}
                        closeDialog={closeDialogoLocalidade}
                        cliente={selection} />}

                <div className={classes.box}>
                    <Paper className={classes.boxPrancheta} elevation={7}>
                        <div className={classes.boxDataGrid}>
                            <ThemeProvider theme={theme}>
                                <DataGrid
                                    rows={listCliente}
                                    disableColumnMenu
                                    disableColumnReorder
                                    id="cli_id"
                                    spacing={0}
                                    direction="column"
                                    headerAlign="center"
                                    rowHeight={50}
                                    pageSize={15}
                                    onRowSelected={(newSelection) => {
                                        setSelectionItem(newSelection.data);
                                        setSelected(true);
                                    }}
                                    components={{
                                        Toolbar: CustomToolbar,
                                    }}
                                    columns={[
                                        {
                                            field: "cli_id",
                                            headerName: "Id",
                                            headerClassName: "header_grid",
                                            align: "center",
                                            type: "string",
                                            headerAlign: "center",
                                            flex: 1,
                                            sortable: false,
                                        },
                                        {
                                            field: "cli_nome",
                                            headerName: "Nome",
                                            align: "center",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            flex: 1,
                                        },
                                        {
                                            field: "cli_apelido",
                                            headerName: "Apelido",
                                            align: "center",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            width: 225,
                                            flex: 1,
                                        },
                                        {
                                            field: "cli_check_local",
                                            headerName: "Local",
                                            align: "center",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            width: 225,
                                            flex: 1,
                                        },
                                        {
                                            field: "cal_id",
                                            headerName: "Algoritimo",
                                            align: "center",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            width: 225,
                                            flex: 1,
                                        },

                                        {
                                            field: "created_at",
                                            headerName: "Data de criação",
                                            headerClassName: "header_grid",
                                            align: "center",
                                            type: "string",

                                            headerAlign: "center",
                                            width: 225,
                                            flex: 1,
                                            renderCell: (params) => (
                                                <div>
                                                    {params.value
                                                        ? new Date(params.value)
                                                            .toLocaleString("pt-BR", {
                                                                year: "numeric",
                                                                month: "numeric",
                                                                day: "numeric",
                                                                hour: "numeric",
                                                                minute: "numeric",
                                                                second: "numeric",
                                                            })
                                                            .replace(",", "")
                                                        : null}
                                                </div>
                                            ),
                                        },
                                        {
                                            field: "updated_at",
                                            headerName: "Última atualização",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            width: 225,
                                            align: "center",
                                            flex: 1,
                                            renderCell: (params) => (
                                                <div>
                                                    {params.value
                                                        ? new Date(params.value)
                                                            .toLocaleString("pt-BR", {
                                                                year: "numeric",
                                                                month: "numeric",
                                                                day: "numeric",
                                                                hour: "numeric",
                                                                minute: "numeric",
                                                                second: "numeric",
                                                            })
                                                            .replace(",", "")
                                                        : null}
                                                </div>
                                            ),
                                        },
                                    ]}
                                />
                            </ThemeProvider>
                        </div>
                        <div className={classes.fab}>
                            <Tooltip title="Novo Cliente">
                                <Fab
                                    color="primary"
                                    aria-label="add"
                                    onClick={newRecord}
                                    variant="extended"
                                    style={{ margin: "5px", height: "40px" }}
                                >
                                    <AddIcon />
                                </Fab>
                            </Tooltip>
                            <Tooltip title="Editar Cliente">
                                <Fab
                                    color="primary"
                                    aria-label="edit"
                                    disabled={!selected}
                                    onClick={editRecord}
                                    variant="extended"
                                    style={{ margin: "5px", height: "40px" }}
                                >
                                    <EditIcon />
                                </Fab>
                            </Tooltip>
                            <Tooltip title="Seleção de Sites">
                                <Fab
                                    color="primary"
                                    aria-label="addCliente"
                                    disabled={!selected}
                                    variant="extended"
                                    onClick={assignClienteToSite}
                                    style={{ margin: "5px", height: "40px" }}
                                >
                                    <FlipIcon />
                                </Fab>
                            </Tooltip>
                            <Tooltip title="Seleção de Serviços">
                                <Fab
                                    color="primary"
                                    aria-label="addServico"
                                    disabled={!selected}
                                    variant="extended"
                                    onClick={assignClienteToServico}
                                    style={{ margin: "5px", height: "40px" }}
                                >
                                    <AddToQueueIcon />
                                </Fab>
                            </Tooltip>
                            <Tooltip title="Localidades">
                                <Fab
                                    color="primary"
                                    aria-label="addServico"
                                    disabled={!selected}
                                    variant="extended"
                                    onClick={openDialogoLocalidade}
                                    style={{ margin: "5px", height: "40px" }}
                                >
                                    <AddHomeWork />
                                </Fab>
                            </Tooltip>
                        </div>
                    </Paper>
                </div>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Pagina
                authState={authState}
                Content={Content}
                HeaderDesc="MANUTENÇÃO DE CLIENTES"
            />
        </Fragment>
    );
}
